export default {
  meta: {
    title: '新增销售单'
  }
};
